// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/cloudweb-20208-onprem-release-25-3-4.202602201412/" + chunkId + ".chunk.js";
};